import { apiClient } from "@api/client";
import { request } from "@api/request";

interface ClinicRole {
  id: string;
  name: string;
}

export const rolesClient = {
  list: (): Promise<ClinicRole[]> =>
    request(() => apiClient.GET("/roles", {})).then((roles) =>
      roles.map((r) => ({ id: r.uuid, name: r.name })),
    ),
};
